<template>
<div class="element-box-tp">
  <div class="inline-profile-tiles">
    <div class="row">
      <div class="col-4 col-sm-3 col-xxl-2" v-for="s in events">
        <div class="profile-tile profile-tile-inlined">
            <router-link class="profile-tile-box faded" :to="{query: {sport: s.ID, onLive: 1}}">
                <div class="pt-user-name">{{ s.Sport }} ({{ s.Count }})</div>
            </router-link>
        </div>
      </div>
    </div>
  </div>
</div>
  </template>
  
  <script>
  export default {
    name: 'hello',
    data () {
      return {
        events: []
      }
    },
    mounted () {
        this.fetchEvents ()
    },
    methods: {
        async fetchEvents () {
				await this.$http.get(bsapi + 'api/v2/fixture/count?onLive=1', {
						params: {
							withoutMatch: 1,
							onLive: this.onlive,
							app: this.$root.app.id,
							locale: window.locale
						}
					}).then(response => {
						// get body data

						this.events = response.body.result;


					}, response => {

					})
			}
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  


// WEBPACK FOOTER //
// src/components/stats/widget/liveSportCount.vue